App.controller('DashboardCtrl', ['$scope', 'Configurator', function ($scope, Configurator) {
    $scope.page = 'dashboard';
    $scope.$emit('page', $scope.page);

    $scope.step = '';
    $scope.$emit('step', $scope.step);


    if (Configurator.isLifeInsuranceWithPaymentsEnabled) {
        if (Configurator.lifeInsuranceWithPayments.insurer === 'Unum') {
            $scope.lifeInsuranceWithPaymentsContent = "Skorzystaj z grupowego ubezpieczenia na życie w Unum Życie TUiR SA" +
                " (dawniej: „Pramerica Życie TUiR SA”) dla Członków Okręgowych Izb Radców Prawnych oraz ich rodzin." +
                "UNUM oferuje szeroki zakres świadczeń, udzielając wsparcia finansowego w przypadku nieprzewidzianych" +
                " zdarzeń losowych. Zapewnij sobie oraz swoim najbliższym ochronę już teraz.";
        } else if (Configurator.lifeInsuranceWithPayments.insurer === 'Pzu') {
            $scope.lifeInsuranceWithPaymentsContent = 'Kontynuacja grupowego ubezpieczenia na życie dla byłych' +
                ' pracowników spółek Grupy PKP oraz członków ich rodzin. PZU Życie oferuje szeroki zakres świadczeń,' +
                ' udzielając wsparcia finansowego w przypadku nieprzewidzianych zdarzeń losowych.' +
                ' Zapewnij sobie oraz swoim najbliższym kontynuację ochrony.'
        } else {
            $scope.lifeInsuranceWithPaymentsContent = '';
        }
    }
}]);